import { useLazyQuery, useMutation, useResult } from '@vue/apollo-composable';
import schema from './schema.graphql';

const useApps = () => {
  const { loading, load, restart, result, variables } = useLazyQuery(
    schema.load,
    {
      filter: {
        schemaType: { equalTo: 'application' },
        hardLinked: { equalTo: false }
      },
      first: 10,
      offset: 0,
      orderBy: 'NATURAL'
    },
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only'
    }
  );

  const { mutate: update } = useMutation(schema.update);

  const items = useResult(result, null, data => {
    return data.objectsConnection.edges.map(item => item.node);
  });

  const totalCount = useResult(result, null, data => {
    return data.objectsConnection.totalCount;
  });

  return {
    load,
    restart,
    loading,
    variables,
    totalCount,
    items,
    update
  };
};

export default useApps;
